<!--  .............. -->
<!--  Main Shared banner -->
<!--  .............. -->
<!--  Component create with Eng Ahmed Abdelhameed Ali -->

<div class="col-12 d-flex justify-content-between align-items-center banner px-16 bg-white">

    <p class="title text-capitalize text-primary fs-24 fw-bolder" *ngIf="title">{{title || '....'}} <span *ngIf="department"> [ {{department}} ]</span> </p>
        <!-- that will be just show in TaskWithoutProject Component -->

    <ng-container *ngIf="isInTasksWithoutProject" >
        <div class="d-flex flex-wrap">
            <div class="d-flex align-items-center  position-relative mx-2" *ngIf="userCompanies.length > 1">
                <select class="form-select fs-18 text-decoration-underline " placeholder="select department" aria-label="select department" name="companies" id="" (change)="changeSelectedCompany($event)">
                    <option value="" disabled >{{"DETAILSTEXT.selectCompanyName"| translate}}</option>
                    <option *ngFor="let item of userCompanies" [value]="item.id" [selected]="item.id==userCompanies[0].id" >{{item.name}} </option>
                </select>
            </div>
            <div class=" d-flex align-items-center  position-relative mx-2" *ngIf="allDepartments.length > 1">
                <select name="departments" class="form-select fs-18 text-decoration-underline " placeholder="select department" aria-label="select department" id="" (change)="changeSelectedDepartment($event)">
                    <option value="" disabled >{{"DETAILSTEXT.selectDepartmentName"| translate}}</option>
                    <!-- /// Stop For Now -->
                   <!-- <option value="0" selected>Show All</option> 
                   <option [value]="department.id" *ngFor="let department of allDepartments" [value]="department.id"  >{{department.name}}</option>  -->
                    <!-- /// Stop For Now -->

                    <option [value]="department.id" *ngFor="let department of allDepartments" [value]="department.id" [selected]="department.id==allDepartments[0].id" >{{department.name}}</option>
                </select>
                <img src="assets/images/arrow-down.png" alt="" width="16px" height="16px">
            </div>
            <div *ngIf="_Auth.checkPermission('ViewAllTasks')||_Auth.checkPermission('ViewDepartmentTasks')" class="btn btn-outline-secondary" style="min-width: fit-content;" (click)="open()"  [hidden]="!hasPermissionForTasks">{{"GENERAL.EMPLOYEETasks"|translate}}</div>

        </div>
    </ng-container>
        <!-- that will be just show in TaskWithoutProject Component -->

    <div class="d-flex flex-wrap">

        <div class="d-flex justify-content-center align-items-center icons">
            <button class="btn btn-blue text-white text-capitalize fs-6 p-8 px-30 button-add" *ngIf="btnAddText != null&&ShowAdd" (click)="openADD()">+ {{btnAddText}}</button>

            <!-- -------------------------- will be used later -------------------------- -->

            <!-- <div class="search-box text-gray-500">
                <button class="btn-search border-radius-4 shadow-sm" (click)="openSearch=!openSearch">
                    <i class="fas fa-search" *ngIf="!openSearch"></i>
                    <i class="bi bi-x" *ngIf="openSearch"></i>
                </button>
                <div class="input-search" (click)="openSearch=true"
                    [ngStyle]="{'width':(openSearch)? '300px':'0px','visibility': openSearch?'visible':'hidden'}">
                    <ng-select (blur)="openSearch=!openSearch"
                        class="select border-gray-500 form-control ng-select-customization w-100 border-radius-8 border-width-05"
                        [items]="itemsList" (change)="operFilter()" formControlName="Client_Id" bindLabel="name"
                        bindValue="id"></ng-select>
                </div>
            </div>  -->


            <!-- -------------------------- Filter Button -------------------------- -->
            <button class="btn border-radius-4 shadow-sm m-1 btn-filter mx-2" (click)="this.openFilter.emit('')" *ngIf="showFilter">
                <i class="bi bi-funnel fs-5"></i>
            </button>
            <button class="btn border-radius-4 shadow-sm m-1 btn-filter mx-2" (click)="openClendarr()" *ngIf="ShowCalendar">
                <i class="bi bi-calendar4"></i>
            </button>
        </div>
        
        <div class="col-sm-4 d-flex align-items-center  position-relative mx-2" *ngIf="itemsList.length">
            <select class="form-select fs-18 text-decoration-underline " placeholder="select department" aria-label="select department" (change)="change($event)" [(ngModel)]="companyID">
                <option value="" selected></option>
                <option [value]="item.id" *ngFor="let item of itemsList">{{item.name}}</option>
            </select>
            <img src="assets/images/arrow-down.png" alt="" width="16px" height="16px">
        </div>
        
        
    </div>
    
</div>
